import { useEffect } from 'react';
import { IS_LOCAL, loadScript, oneTrustConsent, oneTrustStartScript, oneTrustTemplate } from '../utils/oneTrustConfig';
import ErrorBoundary from '../views/common/ErrorBoundary';

const OneTrustCookies = () => {
  useEffect(() => {
    const init = async () => {
      if (!IS_LOCAL) {
        await loadScript(oneTrustConsent);
        await loadScript(oneTrustTemplate);
        void loadScript(oneTrustStartScript);
      }
    };

    init();
  }, []);

  return null;
};

const CookiesComponent = () => {
  return (
    <ErrorBoundary fallbackComponent={() => <></>}>
      <OneTrustCookies />
    </ErrorBoundary>
  );
};

export default CookiesComponent;
